
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.466.522h6.416v3.695h4.23v1.385m.145 2.573v2.936m0 0v2.936m0-2.936h3.209m-3.209 0H8.976m-3.135.957H1.466V.047m10.799 4.036L8.04.392","stroke":"currentColor"}})])
          )
        }
      }
    